
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselectNew.vue";

import SkillMultiselectItem from "@/components/skills/SkillMultiselectItem.vue";
import SkillMultiselectOption from "@/entities/SkillMultiselectOption";

@Component({
  components: {
    SkillMultiselectItem,
    SkillsMultiselect,
  },
})
export default class CustomSkillsMultiselect extends Vue {
  @Prop({ type: Array, required: true }) readonly previouslyChosenSkillsIds!: number[];
  @Prop({ type: String, default: "Add new skill" }) readonly customSkillLabel!: string;
  @Prop({ type: String, default: "Add new skill" }) readonly newSkillLabel!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Number, default: undefined }) readonly max?: number;
  @Prop({ type: String, default: "" }) readonly getParentContainer!: string;
  @Prop({ type: String, default: null }) readonly companyId?: string;

  newSkillsNames: string[] = [];
  skillsIdsFromDB: number[] = [];
  searchQuery: string = "";

  @Watch("previouslyChosenSkillsIds", { immediate: true })
  onSkillsIdsChanged(): void {
    this.skillsIdsFromDB = this.previouslyChosenSkillsIds;
  }

  search(query: string) {
    this.searchQuery = query;
  }

  updateSkillList(skillsIdsFromDB: number[], allChosenSkills: SkillMultiselectOption[]): void {
    // this.skillsIdsFromDB = skillsIdsFromDB;

    const newSkillsNames = allChosenSkills
      .filter(chosenSkill => Number(chosenSkill.id) < 0)
      .map(({ name }) => name);

    this.$emit("skillsListUpdated", skillsIdsFromDB, newSkillsNames, allChosenSkills);
  }
}
